import classNames from 'classnames';
import { includes, isEmpty } from 'lodash';
import React from 'react';

import { LocalizedMessage } from 'core/l10n/components';
import * as OvationsApi from 'core/ovations-api';
import { questionFieldIsDisabled, questionFieldIsRequired } from 'core/ovations-components/QuestionField';
import { removeFirst } from 'core/util/arrays';

import { FormGroup, Input, Label } from 'reactstrap';

import QuestionFieldProps from './definitions/QuestionFieldProps';

export type MultiSelectQuestionFieldProps = QuestionFieldProps<
    OvationsApi.Types.PromotionMultiSelectQuestion,
    OvationsApi.Types.PromotionMultiSelectQuestionAnswer
>;

const MultiSelectQuestionField: React.SFC<MultiSelectQuestionFieldProps> = (props) => {
    const { promotionQuestion } = props;
    const answerValues = props.answer ? props.answer.selections : [];

    const onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const { checked, value } = e.currentTarget;
        const multiSelectAnswers = checked
            ? [...answerValues, value].sort()
            : removeFirst(answerValues, (option) => option === value);
        const answer: OvationsApi.Types.PromotionMultiSelectQuestionAnswer = {
            type: OvationsApi.Enums.QuestionType.MultiSelect,
            selections: multiSelectAnswers,
        };
        if (props.onChange) {
            props.onChange(answer);
        }
    };
    const required = questionFieldIsRequired(props);
    const isInvalid = required && isEmpty(answerValues);

    return (
        <>
            {promotionQuestion.options.map((option: string, index: number) => (
                <FormGroup check key={index} className="my-2">
                    <Label check className="text-nowrap">
                        <Input
                            type="checkbox"
                            name={promotionQuestion.id}
                            disabled={questionFieldIsDisabled(props)}
                            required={isInvalid}
                            onChange={onChange}
                            value={option}
                            checked={!!props.answer && includes(props.answer.selections, option)}
                        />
                        {option}
                    </Label>
                </FormGroup>
            ))}

            <div className={classNames({ 'is-invalid': isInvalid })}>
                <span className="invalid-feedback">
                    <LocalizedMessage id="questionForm_errorMessage_requiredField" />
                </span>
            </div>
        </>
    );
};

export default MultiSelectQuestionField;
